import { render } from "./AddonLivestream.vue?vue&type=template&id=d8b9dc54&scoped=true"
import script from "./AddonLivestream.vue?vue&type=script&lang=js"
export * from "./AddonLivestream.vue?vue&type=script&lang=js"

import "./AddonLivestream.vue?vue&type=style&index=0&id=d8b9dc54&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b9dc54"]])

export default __exports__